module.exports = __webpack_public_path__ + "img/David.6fe26c30.jpg";